// extracted by mini-css-extract-plugin
module.exports = {"Check":"Check_Check__1xUBd","Checked":"Check_Checked__34ju2"};